import { render, staticRenderFns } from "./SetConfigurationOption.vue?vue&type=template&id=4521638f&"
import script from "./SetConfigurationOption.vue?vue&type=script&lang=ts&"
export * from "./SetConfigurationOption.vue?vue&type=script&lang=ts&"
import style0 from "./SetConfigurationOption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports